"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ac_1 = require("@app/ac");
const delete_timeoff_category_1 = require("@app/ac/delete-timeoff-category");
const time_input_1 = require("@app/component/ui/input/time-input/time-input");
const request_timeoff_category_create_1 = require("@app/request/timeoff-category/request-timeoff-category-create");
const request_timeoff_category_update_1 = require("@app/request/timeoff-category/request-timeoff-category-update");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const getSanitizedCategoriesList_1 = require("@app/util/getSanitizedCategoriesList");
const useWorkspace_1 = require("@app/util/hooks/useWorkspace");
const sentry_error_1 = require("@app/util/sentry/sentry-error");
const _ui_1 = require("@ui");
const HOURS_IN_A_DAY = 24;
const UnavailabilityAdd = ({ initialData }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId);
    const ws = (0, useWorkspace_1.useWorkspace)();
    if (!(0, util_1.isValue)(ws)) {
        throw new sentry_error_1.SentryError('unavailability-category-add: workspace/workspaceId cannot be null or undefined');
    }
    const isUpdate = react_1.default.useRef((0, util_1.isValue)(initialData?.id));
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [form, setForm] = (0, react_1.useState)({
        title: initialData?.title ?? null,
        tag: initialData?.tag ?? null,
        consider: initialData?.consider ?? true,
        vacation: initialData?.vacation ?? false,
        timeInLieu: initialData?.timeInLieu ?? false,
        maxYearlyNumber: initialData?.maxYearlyNumber ?? 0,
        displayWorkTimeAsDays: initialData?.displayWorkTimeAsDays ?? true,
        employeeCanRequest: initialData?.approveAutomatically
            ? 'auto'
            : (initialData?.employeeCanRequest ?? false),
        customId: initialData?.customId ?? null,
    });
    const deleteTimeOffCategory = (0, delete_timeoff_category_1.useDeleteTimeOffCategoryMutation)();
    const trueFalseOptions = [
        {
            label: (0, util_1.t)('YES'),
            value: true,
        },
        {
            label: (0, util_1.t)('NO'),
            value: false,
        },
    ];
    const displayWorkTimeAsDaysOptions = [
        {
            label: (0, util_1.t)('DAYS'),
            value: true,
        },
        {
            label: (0, util_1.t)('HOURS2'),
            value: false,
        },
    ];
    const allowDisallowOptions = [
        {
            label: (0, util_1.t)('YES'),
            value: true,
        },
        {
            label: (0, util_1.t)('AUTOMATICALLY'),
            value: 'auto',
        },
        {
            label: (0, util_1.t)('NO'),
            value: false,
        },
    ];
    const [errors, setErrors] = (0, react_1.useState)([]);
    const normalizeComparable = (value) => {
        return value?.trim().toLocaleLowerCase() ?? '';
    };
    const validateForm = (nextForm) => {
        const nextErrors = [];
        const normalizedTitle = nextForm.title?.trim() ?? '';
        const normalizedTag = nextForm.tag?.trim() ?? '';
        const normalizedCustomId = nextForm.customId?.trim() ?? '';
        if (!normalizedTitle) {
            nextErrors.push('titleMissing');
        }
        if (!normalizedTag) {
            nextErrors.push('tagMissing');
        }
        const maxYearlyNumber = Number(nextForm.maxYearlyNumber);
        if (Number.isNaN(maxYearlyNumber) ||
            maxYearlyNumber < 0 ||
            maxYearlyNumber > 365 * (nextForm.displayWorkTimeAsDays ? 1 : HOURS_IN_A_DAY)) {
            nextErrors.push('maxYearlyNumberOutOfRange');
        }
        const currentCategoryId = initialData?.id;
        const categories = (0, getSanitizedCategoriesList_1.getSanitizedCategoriesList)(ws.unavailabilityCategories);
        const hasDuplicateTag = categories.some((category) => {
            if ((0, util_1.isValue)(currentCategoryId) && category.id === currentCategoryId) {
                return false;
            }
            return (normalizeComparable(category.tag) === normalizeComparable(normalizedTag) &&
                !category.archived);
        });
        if (normalizedTag && hasDuplicateTag) {
            nextErrors.push('duplicateTag');
        }
        const hasDuplicateCustomId = categories.some((category) => {
            if ((0, util_1.isValue)(currentCategoryId) && category.id === currentCategoryId) {
                return false;
            }
            return (normalizeComparable(category.customId ?? null) ===
                normalizeComparable(normalizedCustomId) && !category.archived);
        });
        if (normalizedCustomId && hasDuplicateCustomId) {
            nextErrors.push('duplicateCustomId');
        }
        return nextErrors;
    };
    const getErrorMessage = (error, x) => {
        switch (error) {
            case 'titleMissing':
            case 'tagMissing':
                return (0, util_1.t)('FORM_ERR_MISSING_REQUIRED');
            case 'duplicateTag':
                return (0, util_1.t)('CUSTOMATTRIBUTE_EXISTING_ID_ERROR');
            case 'duplicateCustomId':
                return (0, util_1.t)('CUSTOMATTRIBUTE_EXISTING_ID_ERROR');
            case 'maxYearlyNumberOutOfRange':
                return (0, util_1.t)('MAX_VALUE_X', { x });
            default:
                return '';
        }
    };
    const getFieldErrorMessage = (fieldErrors, x) => {
        const firstFieldError = errors.find((error) => fieldErrors.includes(error));
        return (0, util_1.isValue)(firstFieldError) ? getErrorMessage(firstFieldError, x) : undefined;
    };
    const canSave = () => {
        if (!form)
            return false;
        if (validateForm(form).length > 0)
            return false;
        if (isUpdate.current && !initialData?.id)
            return false;
        return true;
    };
    const handleCreate = async () => {
        const nextErrors = validateForm(form);
        setErrors(nextErrors);
        if (nextErrors.length > 0) {
            return;
        }
        setIsLoading(true);
        const maxYearlyNumber = Number(form.maxYearlyNumber);
        const normalizedMaxYearlyNumber = Number.isNaN(maxYearlyNumber)
            ? 0
            : maxYearlyNumber;
        const approveAutomatically = form.employeeCanRequest === 'auto';
        const normalizedEmployeeCanRequest = approveAutomatically
            ? true
            : (0, util_1.toBoolean)(form.employeeCanRequest);
        const normalizedTitle = form.title?.trim() ?? '';
        const normalizedTag = form.tag?.trim() ?? '';
        const normalizedCustomId = form.customId?.trim() ?? '';
        const data = {
            title: normalizedTitle,
            tag: normalizedTag,
            consider: form.consider,
            vacation: form.consider ? form.vacation : undefined,
            timeInLieu: form.timeInLieu,
            maxYearlyNumber: form.consider ? normalizedMaxYearlyNumber : undefined,
            displayWorkTimeAsDays: form.displayWorkTimeAsDays,
            employeeCanRequest: normalizedEmployeeCanRequest,
            approveAutomatically,
            customId: normalizedCustomId || null,
        };
        if (isUpdate.current) {
            const id = initialData?.id;
            if (!(0, util_1.isValue)(id)) {
                throw new sentry_error_1.SentryError('unavailability-category-add: category Id cannot be null or undefined');
            }
            try {
                await (0, request_timeoff_category_update_1.requestTimeOffCategoryUpdate)({
                    workspace: ws.id,
                    data,
                    id,
                });
            }
            catch (e) {
                setIsLoading(false);
                return;
            }
            // old update code
            // const initialCategoryId = initialData?.id
            // if (!isValue(initialCategoryId)) {
            //   setIsLoading(false)
            //   return
            // }
            // const categoryIndex = existingCategories.findIndex(
            //   (category) => category.id === initialCategoryId
            // )
            // if (categoryIndex >= 0) {
            //   existingCategories[categoryIndex] = {
            //     ...existingCategories[categoryIndex],
            //     ...data,
            //     id: initialCategoryId,
            //     archived: initialData?.archived ?? false,
            //   }
            // }
        }
        else {
            try {
                await (0, request_timeoff_category_create_1.requestTimeOffCategoryCreate)({
                    workspace: ws.id,
                    data,
                });
            }
            catch (e) {
                setIsLoading(false);
                return;
            }
            // old create new code
            // existingCategories = [...existingCategories, data]
        }
        try {
            // old code to send request
            // await requestWorkspaceUpdate(
            //   {
            //     id: workspaceId,
            //     data: {
            //       unavailabilityCategories: existingCategories,
            //     },
            //   },
            //   auth
            // )
            await dispatch((0, ac_1.loadWorkspaceDetail)(workspaceId));
        }
        catch (error) {
            console.log('Time off category create/update failed', error);
        }
        finally {
            setIsLoading(false);
            dispatch((0, ac_1.setModal)(null));
        }
    };
    const handleSet = (key, value) => {
        setForm((prev) => {
            const next = {
                ...prev,
                [key]: value,
            };
            if (ws.displayVacationsAsDays) {
                if (key === 'vacation' && value === true) {
                    next.displayWorkTimeAsDays = true;
                }
                else if (key === 'displayWorkTimeAsDays' && value === false) {
                    next.vacation = false;
                }
            }
            setErrors(validateForm(next));
            return next;
        });
    };
    const isDisabledByConsider = () => {
        return !form.consider;
    };
    return (react_1.default.createElement(_ui_1.Modal, { testid: 'timeoff-category-modal', size: _ui_1.Modal.SIZES.M, className: 'ds-modal-unavailability-category-add', extraHeaderButtons: isUpdate.current
            ? [
                react_1.default.createElement(_ui_1.Icon, { key: 'delete', testid: 'delete-category-button', ico: _ui_1.Icon.ICONS.delete, color: _ui_1.Icon.COLORS.RED, onClick: () => {
                        dispatch((0, ac_1.setModal)('confirm', {
                            title: (0, util_1.t)('WS_SETTINGS_CONFIRM_DELETE_CAT'),
                            subtitle: (0, util_1.t)('TIMEOFF_CATEGORY_DELETE_CONFIRMATION'),
                            confirmLabel: (0, util_1.t)('DELETE'),
                            onConfirm: () => {
                                const id = initialData?.id;
                                if ((0, util_1.isValue)(id)) {
                                    // TODO: NEW DELETE TIMEOFF CATEGORY MUTATION
                                    deleteTimeOffCategory([id]);
                                }
                            },
                            cancelLabel: (0, util_1.t)('CLOSE'),
                            onCancel: () => { },
                            overSidebar: true,
                        }));
                    }, size: _ui_1.Icon.SIZES.SMALL }),
            ]
            : [], footerContent: react_1.default.createElement(_ui_1.Flex, { stretch: true },
            react_1.default.createElement(_ui_1.Button, { size: _ui_1.Button.SIZES.FULL, label: (0, util_1.t)('CLOSE'), onClick: async () => await dispatch((0, ac_1.setModal)(null)) }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(_ui_1.Button, { testid: 'save-category-button', disabled: !canSave() || isLoading, loading: isLoading, onClickActiveWhenDisabled: true, size: _ui_1.Button.SIZES.FULL, style: _ui_1.Button.STYLES.CONTAINED, label: (0, util_1.t)(isUpdate.current ? 'EDIT' : 'CREATE'), onClick: handleCreate })), headerContent: react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)(isUpdate.current
            ? 'EDIT_TIMEOFF_CATEGORY'
            : 'WS_SETTINGS_CARD_UNAV_CAT_ADD')), sections: [
            react_1.default.createElement(react_1.default.Fragment, { key: 'first' },
                react_1.default.createElement(_ui_1.Flex, null,
                    react_1.default.createElement("div", { style: { width: '25%', flexShrink: 0 } },
                        react_1.default.createElement(_ui_1.Input, { testid: 'timeoff-category-short-name-input', label: (0, util_1.t)('SHORT'), hasError: Boolean(errors?.find((e) => e === 'tagMissing' || e === 'duplicateTag')), errorMessage: getFieldErrorMessage(['tagMissing', 'duplicateTag']), onChange: (value) => handleSet('tag', value), placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_TAG_PLACEHOLDER')), value: (0, maybe_unwrap_1.unwrapMaybe)(form.tag), maxLength: 3, size: _ui_1.Input.SIZES.FULL_WIDTH })),
                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
                    react_1.default.createElement(_ui_1.Input, { testid: 'timeoff-category-name-input', label: (0, util_1.t)('NAME_V2'), hasError: Boolean(errors?.find((e) => e === 'titleMissing')), errorMessage: getFieldErrorMessage(['titleMissing']), onChange: (value) => handleSet('title', value), placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_TITLE_PLACEHOLDER')), value: (0, maybe_unwrap_1.unwrapMaybe)(form.title), size: _ui_1.Input.SIZES.FULL_WIDTH })),
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_10 }),
                react_1.default.createElement(_ui_1.Input, { label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_CUSTOM_ID'), hasError: Boolean(errors?.find((e) => e === 'duplicateCustomId')), errorMessage: getFieldErrorMessage(['duplicateCustomId']), onChange: (value) => handleSet('customId', value), value: (0, maybe_unwrap_1.unwrapMaybe)(form.customId), size: _ui_1.Input.SIZES.FULL_WIDTH }),
                react_1.default.createElement("div", { style: { width: '100%', marginBottom: '0.625rem' } },
                    react_1.default.createElement(_ui_1.Select, { testid: 'can-employee-request-select', label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_ALLOW'), options: allowDisallowOptions, onChange: (value) => handleSet('employeeCanRequest', value), value: form.employeeCanRequest })),
                react_1.default.createElement(_ui_1.Dropdown, { label: (0, util_1.t)('DISPLAY_WORK_TIME_AS_DAYS_SELECT_LABEL'), type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.LIGHT, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, singleSelect: true, options: displayWorkTimeAsDaysOptions, onChange: (v) => {
                        handleSet('displayWorkTimeAsDays', v.value);
                        const _maxYearlyNumber = form.maxYearlyNumber;
                        if (v.value) {
                            handleSet('maxYearlyNumber', _maxYearlyNumber / HOURS_IN_A_DAY);
                        }
                        else {
                            handleSet('maxYearlyNumber', _maxYearlyNumber * HOURS_IN_A_DAY);
                        }
                    }, value: displayWorkTimeAsDaysOptions.find((o) => o.value === form.displayWorkTimeAsDays), disabled: ws.displayVacationsAsDays === true && form.vacation }),
                form.displayWorkTimeAsDays ? (react_1.default.createElement(_ui_1.Input, { label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_FUND') +
                        ` - ${(0, util_1.t)('DAYS').toLocaleLowerCase()}`, hasError: Boolean(errors?.find((e) => e === 'maxYearlyNumberOutOfRange')), errorMessage: getFieldErrorMessage(['maxYearlyNumberOutOfRange'], 365), onChange: (value) => handleSet('maxYearlyNumber', Number(value) || 0), type: 'number', min: 0, max: 365, step: 1, placeholder: '20', size: _ui_1.Input.SIZES.FULL_WIDTH, value: form.maxYearlyNumber, disabled: isDisabledByConsider() })) : (react_1.default.createElement("div", { style: { marginBottom: '0.625rem' } },
                    react_1.default.createElement(time_input_1.TimeInput, { label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_FUND') +
                            ` - ${(0, util_1.t)('HOURS2')}`.toLocaleLowerCase(), maxHours: 8760, value: (form.maxYearlyNumber || 0) * 60, onChange: (value) => handleSet('maxYearlyNumber', value / 60), disabled: isDisabledByConsider() }))),
                react_1.default.createElement("div", { style: { width: '100%', marginBottom: '0.625rem' } },
                    react_1.default.createElement(_ui_1.Select, { label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_CONSIDER'), options: trueFalseOptions, onChange: (value) => handleSet('consider', (0, util_1.toBoolean)(value)), value: form.consider })),
                react_1.default.createElement("div", { style: { width: '100%', marginBottom: '0.625rem' } },
                    react_1.default.createElement(_ui_1.Select, { label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_COUNT_VACATION'), options: trueFalseOptions, placeholder: (0, util_1.t)('CHOOSE_PERSONAL'), onChange: (value) => handleSet('vacation', (0, util_1.toBoolean)(value)), value: form.vacation, disabled: isDisabledByConsider() })),
                react_1.default.createElement("div", { style: { width: '100%', marginBottom: '0.625rem' } },
                    react_1.default.createElement(_ui_1.Select, { label: (0, util_1.t)('WS_SETTINGS_CARD_UNAV_CAT_INLIEU'), options: trueFalseOptions, placeholder: (0, util_1.t)('CHOOSE_PERSONAL'), onChange: (value) => handleSet('timeInLieu', (0, util_1.toBoolean)(value)), value: form.timeInLieu, disabled: isDisabledByConsider() }))),
        ] }));
};
exports.default = UnavailabilityAdd;
